export const E_BOOK = 'eBook';
export const EREADER = 'EREADER';
export const READER = 'READER';
export const E_BOOKS = 'eBooks';
export const ALF_COURSE_WARE = 'Courseware';
export const PALMER = 'PALMER';
